import {CONDITIONAL_METRICS} from "../commons/dataStore/PackageResultsData";

/**
 * CONDITIONAL_METRICS: Metrics Names that should only appear when data is present
 * Method implements conditional metric handling to prevent displaying metrics (like "Jackpot Buffered")
 * when no corresponding data exists in response received from backend
 *
 * Processes row mapping based on conditional metrics
 * @param {Array} metricData - The metrics data array
 * @param {Array} rowMapping - The row mapping configuration array
 * @returns {Array} - Filtered row mappings based on available metric data
 */
export const processConditionalMetrics = (metricData, rowMapping) => {
    if (!Array.isArray(metricData) || !Array.isArray(rowMapping) || !Array.isArray(CONDITIONAL_METRICS) || !metricData.length > 0) {
        return rowMapping;
    }

    // Get all package statuses from the metric data
    const existingStatuses = new Set(
        metricData.map(item => {
            return item.metaDataMap && item.metaDataMap.direction
                ? `${item.packageStatus} (${item.metaDataMap.direction})`
                : item.packageStatus;
        })
    );


    return rowMapping.filter(section => {
        // If section is a conditional metric, check if it exists in the data
        if (CONDITIONAL_METRICS.includes(section.Section)) {
            return existingStatuses.has(section.Section);
        }
        
        // For sections with subsections, filter out conditional metrics from subsections
        if (section.Subsections) {
            if (Array.isArray(section.Subsections)) {
                section.Subsections = section.Subsections.filter(subsection => {
                    if (typeof subsection === 'object') {
                        // Handle nested subsections
                        if (CONDITIONAL_METRICS.includes(subsection.Section)) {
                            return existingStatuses.has(subsection.Section);
                        }
                        if (subsection.Subsections) {
                            subsection.Subsections = subsection.Subsections.filter(
                                nestedSubsection => !CONDITIONAL_METRICS.includes(nestedSubsection) || existingStatuses.has(nestedSubsection)
                            );
                        }
                        return true;
                    }
                    return !CONDITIONAL_METRICS.includes(subsection) || existingStatuses.has(subsection);
                });
            }
        }
        return true;
    });
};


// WEBPACK FOOTER //
// ./src/util/MetricUtils.js